// 🔒 AUTH-GUARDS-2026-05 — Single source of truth para post-login routing.
// Devuelve la primera ruta a la que un usuario debe aterrizar según sus permisos.
// Usada tanto por <RoleGate> (fallback) como por Login.js (navigate inicial)
// para evitar flicker /tables → /kitchen al iniciar sesión como cocina.
export function firstAllowedRoute(user) {
  if (!user) return '/login';
  const isAdmin = user.role === 'admin' || (user.role_level || 0) >= 100 || user.is_super_admin === true;
  if (isAdmin) return '/dashboard';
  const p = user.permissions || {};
  // Priority: tables (operativo) → kitchen (KDS) → reports → cash-register → dashboard
  if (p.open_table || p.access_all_tables) return '/tables';
  if (p.send_kitchen || p.receive_orders) return '/kitchen';
  if (p.view_reports) return '/reports';
  if (p.access_caja) return '/cash-register';
  if (p.view_dashboard) return '/dashboard';
  return '/dashboard';
}

// Same logic but using a hasPermission() callback (used by RoleGate inside App.js).
export function firstAllowedRouteBy(hasPermission, isAdmin) {
  if (isAdmin) return '/dashboard';
  if (hasPermission('open_table') || hasPermission('access_all_tables')) return '/tables';
  if (hasPermission('send_kitchen') || hasPermission('receive_orders')) return '/kitchen';
  if (hasPermission('view_reports')) return '/reports';
  if (hasPermission('access_caja')) return '/cash-register';
  if (hasPermission('view_dashboard')) return '/dashboard';
  return '/dashboard';
}
